<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-20 22:33:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/logistics/index.vue
-->
<template>
  <!-- 订单详情物流 -->
  <div class="detail_log">
    <title-bar-back :title="'订单追踪'" @back="back">
      <!-- icon -->
      <div class="left font12 icon_list">
        <!-- <img
          src="@/assets/product/icon_service@2x.png"
          alt=""
          class="left_icon"
        /> -->
        <!-- <div class="icon_name font10 font_weight400 colo087 line_height_14">
          <pharmacist />
        </div> -->
        <!-- 客服 -->
        <pharmacist />
      </div>
    </title-bar-back>
    <div v-if="this.$route.query.purPage !== 'milkplan'">
      <!-- 切换 -->
      <switch-bar @switchSku="switchSku" />
      <!-- 订单状态信息 -->
      <order-status-det :chooseIndex="chooseIndex" />
    </div>
    <!-- 物流信息 -->
    <log-list />
  </div>
</template>
<script>
const Pharmacist = () =>
  import("@/components/Pharmacist").then(m => m.default || m);
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import LogList from "./components/LogList";
import SwitchBar from "./components/SwitchBar";
import OrderStatusDet from "./components/OrderStatusDet";
export default {
  name: "Logistics",
  components: {
    TitleBarBack,
    LogList,
    SwitchBar,
    OrderStatusDet,
    Pharmacist
  },
  data() {
    return {
      chooseIndex: parseInt(this.$route.query.packageIndex)
    };
  },
  created() {
    if (this.$route.query.purPage == "milkplan") {
      this.getMlikPlanTrackData();
    } else {
      this.getData();
      this.getTrackData();
    }
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    },
    getTrackingDataBySubOrderSn() {
      return this.$store.getters.getTrackingDataBySubOrderSn;
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    // 获取详情数据
    getData() {
      const params = {
        orderSn: this.$route.query.orderSn
      };
      this.$store
        .dispatch("order/getUserOrder", { params })
        .then(() => {})
        .catch(() => {});
    },
    getTrackData() {
      // 获取物流数据 getTrackingDataBySubOrderSn
      const params1 = {
        subOrderSn: this.$route.query.subOrderSn
      };
      this.$store
        .dispatch("order/getTrackingDataBySubOrderSn", { params: params1 })
        .then(() => {})
        .catch(() => {});
    },
    getMlikPlanTrackData() {
      // 获取物流数据 getTrackingDataByTrackingNo
      const params = {
        trackingNo: this.$route.query.trackingNo
      };
      this.$store
        .dispatch("order/getTrackingDataByTrackingNo", { params })
        .then(() => {})
        .catch(() => {});
    },
    // 切换包裹
    switchSku(index) {
      this.chooseIndex = index;
      // console.log(index, "包裹");
      // 获取物流数据 getTrackingDataBySubOrderSn
      const params = {
        subOrderSn: this.getUserOrder.retailSubOrderList[index].subOrderSn
      };
      this.$store
        .dispatch("order/getTrackingDataBySubOrderSn", { params })
        .then(() => {})
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.detail_log {
  // background: #fff;
  .icon_list {
    padding-left: 4px;
    .left_icon {
      display: block;
      width: 24px;
    }
  }
}
</style>
